import { Box, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';

interface ILectureLinkProps {
  sessionId: string | number;
  eventId: string | number;
  linkSlug: string;
  disabled?: boolean;
  isPoster?: boolean;
  toCoreApp?: boolean;
  children?: ReactNode;
}

export const LectureLink: FC<ILectureLinkProps> = ({
  children,
  eventId,
  sessionId,
  linkSlug,
  disabled,
  isPoster = false,
  toCoreApp = false,
}) => {
  if (disabled) {
    return <Box>{children}</Box>;
  }

  let as = isPoster
    ? `/events/${eventId}/posters/${sessionId}/poster/${linkSlug}`
    : `/events/${eventId}/sessions/${sessionId}/lecture/${linkSlug}`;

  if (toCoreApp) {
    as = `/lecture/${linkSlug}`;
  }

  return (
    <LinkBox as="article" position="relative">
      <LinkOverlay href={as}>{children}</LinkOverlay>
    </LinkBox>
  );
};
